// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.despesas-page {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
}

.filters-bar {
    background: white;
    padding: 24px;
    border-radius: 12px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    margin-bottom: 24px;
    display: flex;
    gap: 20px;
    align-items: flex-end;
    flex-wrap: wrap;
}

/* O alcance da exportação, escrito por baixo da caixa de filtros. Estava só no
   title dos botões, que no telemóvel não aparece — e é no telemóvel que a caixa
   de filtros continua desenhada enquanto a tabela com os filtros de coluna não. */
.export-nota-alcance {
    margin: -16px 0 20px;
    padding: 0 4px;
    font-size: 0.82rem;
    line-height: 1.5;
    color: #4a5568;
}
.export-nota-alcance strong { color: #2d3748; font-weight: 600; }

.filter-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.filter-group label {
    font-size: 0.75rem;
    font-weight: 600;
    color: #718096;
    text-transform: uppercase;
    letter-spacing: 0.05em;
}

.filter-group select,
.filter-group input {
    padding: 10px 14px;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    font-size: 0.95rem;
    color: #2d3748;
    background-color: #fff;
    min-width: 140px;
    transition: all 0.2s;
}

.filter-group select:focus,
.filter-group input:focus {
    outline: none;
    border-color: #4299e1;
    box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.1);
}


.summary-bar {
    background: white;
    border-radius: 12px;
    padding: 10px 20px;
    /* Reduced padding */
    margin-bottom: 24px;
    display: flex;
    gap: 40px;
    border: 1px solid #e2e8f0;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
}

.summary-bar.compact {
    padding: 8px 16px;
    gap: 30px;
}

.summary-item {
    display: flex;
    flex-direction: column;
}

.summary-label {
    font-size: 0.7rem;
    /* Smaller font */
    color: #718096;
    text-transform: uppercase;
    font-weight: 600;
    letter-spacing: 0.05em;
    margin-bottom: 2px;
}

.summary-value {
    font-size: 1.25rem;
    /* Smaller value */
    color: #2d3748;
    font-weight: 700;
    line-height: 1.2;
}

.export-btn {
    display: flex;
    align-items: center;
    line-height: 1.2;
}

.export-btn {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 20px;
    border-radius: 8px;
    font-size: 0.95rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    border: 1px solid #e2e8f0;
    background: white;
}

.export-btn.large {
    padding: 12px 24px;
    font-size: 1rem;
    color: #4a5568;
}

.export-btn:hover {
    background: #f7fafc;
    border-color: #cbd5e0;
}

.export-actions {
    display: flex;
    gap: 10px;
    align-items: center;
}

@media (max-width: 768px) {
    .despesas-page .page-content {
        padding: 0 15px;
        /* Restore side padding, keep top/bottom tight */
    }
}

.manual-active {
    border-style: solid;
    border-color: #ed8936;
    background: #fffaf0;
}

/* Scanner Styles */
#reader {
    width: 100% !important;
    border-radius: 12px;
    overflow: hidden;
}

/* A vista em mosaicos foi retirada: era a tabela sem estado, sem
   miniatura e sem quem lançou, e abria o detalhe errado num movimento
   Revolut. O CSS dela saiu com ela. */

.action-btn {
    background: transparent;
    border: 1px solid #e2e8f0;
    width: 32px;
    height: 32px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s;
    font-size: 1rem;
}

.action-btn:hover {
    background: #ebf8ff;
    border-color: #3182ce;
}

.action-btn-delete {
    background: transparent;
    border: 1px solid #fed7d7;
    width: 32px;
    height: 32px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s;
    font-size: 1rem;
    color: #e53e3e;
}

.action-btn-delete:hover {
    background: #fff5f5;
    border-color: #e53e3e;
}

.btn-cancel-manual {
    background: #fed7d7;
    color: #c53030;
    border: none;
    padding: 12px 24px;
    border-radius: 10px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s;
}

.btn-cancel-manual:hover {
    background: #feb2b2;
}

.btn-scan {
    background: #3182ce;
    color: white;
    border: none;
    padding: 12px 24px;
    border-radius: 10px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    cursor: pointer;
    transition: background 0.2s;
}

.btn-scan:hover {
    background: #2b6cb0;
}

.form-group {
    margin-bottom: 20px;
}

.form-group label {
    display: block;
    margin-bottom: 8px;
    font-weight: 600;
    color: #4a5568;
}

.form-group input,
.form-group select {
    width: 100%;
    padding: 12px;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    font-size: 1rem;
}

.preview-photo {
    width: 100%;
    max-height: 300px;
    object-fit: contain;
    background: #f7fafc;
    border-radius: 12px;
}

.despesas-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 0.9rem;
}

.despesas-table th {
    background: #f8fafc;
    padding: 10px 16px;
    text-align: left;
    font-size: 0.7rem;
    font-weight: 600;
    color: #64748b;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    border-bottom: 2px solid #edf2f7;
}

.despesas-table td {
    padding: 12px 16px;
    /* Slightly tighter */
    border-bottom: 1px solid #edf2f7;
    color: #2d3748;
}

.despesas-table tr:last-child td {
    border-bottom: none;
}

.despesas-table tr:hover td {
    background-color: #f7fafc;
}


.valor-cel {
    font-weight: 700;
    color: #2b6cb0;
    font-size: 1.05rem;
}

/* Capture View Styles */
.capture-mode-active .top-bar {
    background: #f8fafc;
    border-bottom: 1px solid #e2e8f0;
}

/* Ecrã de registo. Esteve definido quatro vezes, com o primeiro par a
   contradizer o segundo em justify-content e min-height — e o comentário do
   primeiro a descrever um efeito que nunca se via. Ficam duas definições, com
   o resultado idêntico ao que estava a ser desenhado. */
.capture-view {
    padding: 20px;
    max-width: 600px;
    margin: 0 auto;
    animation: fadeIn 0.3s ease-out;
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: calc(100vh - 80px);
    overflow-x: hidden;
    width: 100%;
    /* Adjust based on top bar height */
}

@media (max-width: 768px) {
    .capture-view {
        padding: 10px;
        padding-top: 10px;
        min-height: calc(100vh - 60px);
        /* No telemóvel o conteúdo assenta em cima, não a meio. */
        justify-content: flex-start;
    }
}

.capture-hero {
    margin-bottom: 30px;
}

.capture-main-card {
    background: white;
    border: 3px dashed #3182ce;
    border-radius: 20px;
    padding: 26px 20px;
    text-align: center;
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
}

.capture-main-card:hover {
    background: #ebf8ff;
    border-color: #2b6cb0;
    transform: translateY(-5px);
}

.camera-icon-wrapper {
    position: relative;
    width: 68px;
    height: 68px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #3182ce;
    border-radius: 50%;
    color: white;
}

.camera-emoji {
    font-size: 40px;
    z-index: 2;
}

.camera-ring {
    position: absolute;
    width: 100%;
    height: 100%;
    border: 4px solid #3182ce;
    border-radius: 50%;
    animation: pulse 2s infinite;
}

.capture-text h2 {
    margin: 0;
    color: #2d3748;
}

.capture-text p {
    margin: 5px 0 0;
    color: #718096;
    font-size: 0.95rem;
}


.default-card-selector {
    margin-bottom: 20px;
    background: white;
    padding: 15px;
    border-radius: 12px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
}

.default-card-selector label {
    display: block;
    margin-bottom: 8px;
    font-weight: 600;
    color: #4a5568;
    font-size: 0.9rem;
}

.card-dropdown {
    width: 100%;
    padding: 10px;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    font-size: 1rem;
    color: #2d3748;
    background: #f8fafc;
}

.recent-entries-section {
    display: flex;
    flex-direction: column;
    width: 100%;
}


.custom-camera-input {
    width: 100%;
    cursor: pointer;
}

.camera-preview-box {
    width: 100%;
    min-height: 150px;
    background: #f7fafc;
    border: 2px dashed #cbd5e0;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.camera-placeholder {
    text-align: center;
    color: #718096;
}

.camera-placeholder p {
    margin-top: 10px;
    font-weight: 600;
}

@media (max-width: 768px) {
    .mobile-hide {
        display: none !important;
    }

    /* No telemóvel/tablet a página das despesas fica como sempre foi: as secções
       da reconciliação de extratos são ferramentas de secretária e não cabem
       nesta largura. Vale também para quem entra com conta de escritório. */
    .subnav-reconciliador {
        display: none !important;
    }

    .mobile-only {
        display: inline-block !important;
    }

    .top-bar-actions {
        gap: 8px;
    }

    .export-actions.mobile-compact {
        display: flex;
        gap: 5px;
    }

    /* Atenção: hoje esta regra não pega em nenhum botão. Os quatro do ecrã das
       despesas são .export-btn.large, que tem mais especificidade e ganha-lhe o
       padding. O que impede os rótulos de apertarem a fila no telemóvel é serem
       curtos lá (o " do mês" leva .mobile-hide), não esta regra. */
    .export-btn {
        padding: 8px;
        min-width: 40px;
        justify-content: center;
    }

    .filters-bar {
        flex-direction: column;
        align-items: stretch;
    }

    .filter-group select,
    .filter-group input {
        min-width: unset;
    }

    .despesas-table thead {
        display: none;
    }

    .table-container {
        overflow-x: auto;
    }
}

/* Cropper.js - bigger handles for mobile touch (high specificity to override CDN CSS) */
.cropper-crop-box .cropper-point.point-e {
    width: 18px !important;
    height: 36px !important;
    right: -9px !important;
    margin-top: -18px !important;
    background-color: #3182ce !important;
    border-radius: 9px !important;
    opacity: 1 !important;
}

.cropper-crop-box .cropper-point.point-w {
    width: 18px !important;
    height: 36px !important;
    left: -9px !important;
    margin-top: -18px !important;
    background-color: #3182ce !important;
    border-radius: 9px !important;
    opacity: 1 !important;
}

.cropper-crop-box .cropper-point.point-n {
    width: 36px !important;
    height: 18px !important;
    top: -9px !important;
    margin-left: -18px !important;
    background-color: #3182ce !important;
    border-radius: 9px !important;
    opacity: 1 !important;
}

.cropper-crop-box .cropper-point.point-s {
    width: 36px !important;
    height: 18px !important;
    bottom: -9px !important;
    margin-left: -18px !important;
    background-color: #3182ce !important;
    border-radius: 9px !important;
    opacity: 1 !important;
}

.cropper-crop-box .cropper-point.point-ne {
    width: 28px !important;
    height: 28px !important;
    top: -14px !important;
    right: -14px !important;
    background-color: #3182ce !important;
    border-radius: 50% !important;
    opacity: 1 !important;
}

.cropper-crop-box .cropper-point.point-nw {
    width: 28px !important;
    height: 28px !important;
    top: -14px !important;
    left: -14px !important;
    background-color: #3182ce !important;
    border-radius: 50% !important;
    opacity: 1 !important;
}

.cropper-crop-box .cropper-point.point-se {
    width: 28px !important;
    height: 28px !important;
    bottom: -14px !important;
    right: -14px !important;
    background-color: #3182ce !important;
    border-radius: 50% !important;
    opacity: 1 !important;
}

.cropper-crop-box .cropper-point.point-sw {
    width: 28px !important;
    height: 28px !important;
    bottom: -14px !important;
    left: -14px !important;
    background-color: #3182ce !important;
    border-radius: 50% !important;
    opacity: 1 !important;
}

.cropper-crop-box .cropper-line {
    background-color: #3182ce !important;
    opacity: 0.3 !important;
}

.cropper-crop-box .cropper-view-box {
    outline: 2px solid rgba(49, 130, 206, 0.75) !important;
}

.cropper-crop-box .cropper-dashed {
    border-color: rgba(255, 255, 255, 0.5) !important;
}

/* QR Code Preview Box */
.qr-preview-box {
    background: #ebf8ff;
    border: 2px solid #bee3f8;
    border-radius: 12px;
    padding: 16px;
    margin-bottom: 20px;
}

.qr-preview-header {
    font-size: 0.8rem;
    font-weight: 700;
    color: #2b6cb0;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin-bottom: 12px;
}

.qr-preview-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
}

.qr-preview-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.qr-preview-label {
    font-size: 0.75rem;
    color: #718096;
    font-weight: 600;
}

.qr-preview-value {
    font-size: 1.1rem;
    font-weight: 700;
    color: #2d3748;
    font-family: monospace;
}

.qr-preview-valor {
    color: #2b6cb0;
    font-size: 1.3rem;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes pulse {
    0% {
        transform: scale(1);
        opacity: 0.8;
    }

    70% {
        transform: scale(1.3);
        opacity: 0;
    }

    100% {
        transform: scale(1.3);
        opacity: 0;
    }
}
/* ---- Registos tardios ------------------------------------------------------
   Vista que mostra o que foi carregado depois de o mes da fatura ja estar
   fechado. Agrupada por mes da fatura: cada grupo e um mes cuja documentacao
   tem de ser refeita. */
.tardios-wrap { padding: 4px 0 20px; }
.tardios-header {
    display: flex; justify-content: space-between; align-items: flex-start;
    gap: 20px; flex-wrap: wrap; margin-bottom: 18px;
}
.tardios-header h3 { margin: 0 0 4px; font-size: 1.05rem; color: #1e293b; }
.tardios-header p { margin: 0; font-size: 0.82rem; color: #64748b; max-width: 520px; }
.tardios-filtros { display: flex; gap: 14px; align-items: center; flex-wrap: wrap; }
.tardios-filtros label {
    display: flex; align-items: center; gap: 6px;
    font-size: 0.78rem; font-weight: 600; color: #475569;
    background: #fff; border: 1px solid #e2e8f0; border-radius: 8px; padding: 6px 12px;
}
.tardios-filtros input {
    border: 1px solid #e2e8f0; border-radius: 5px; padding: 3px 6px; font-size: 0.82rem;
}
.tardios-filtros input[type="number"] { width: 52px; text-align: center; }

.tardios-info { font-size: 0.88rem; color: #64748b; padding: 14px 0; }
.tardios-ok { color: #166534; font-weight: 600; }
.tardios-erro {
    font-size: 0.85rem; color: #991b1b; background: #fee2e2;
    border: 1px solid #fca5a5; border-radius: 8px; padding: 10px 14px;
}

.tardios-grupo { margin-bottom: 22px; }
.tardios-grupo-titulo {
    display: flex; align-items: center; gap: 10px;
    font-size: 0.86rem; font-weight: 700; color: #92400e;
    background: #fff7ed; border: 1px solid #fed7aa;
    border-radius: 8px 8px 0 0; padding: 9px 14px;
}
.tardios-grupo-total { margin-left: auto; font-variant-numeric: tabular-nums; }
.tardios-tabela { width: 100%; border-collapse: collapse; font-size: 0.82rem; }
.tardios-tabela th {
    background: #f8fafc; text-align: left; font-weight: 700; font-size: 0.72rem;
    text-transform: uppercase; letter-spacing: 0.3px; color: #64748b;
    padding: 7px 10px; border-bottom: 2px solid #e2e8f0;
}
.tardios-tabela td { padding: 7px 10px; border-bottom: 1px solid #f1f5f9; color: #1e293b; }
/* a data de carga e o dado que justifica a linha estar aqui */
.tardios-carga { font-weight: 700; color: #b45309; }

/* faixa de aviso no topo das Despesas */
.tardios-faixa {
    display: flex; align-items: flex-start; gap: 12px;
    background: #fff7ed; border: 1px solid #fdba74; border-radius: 10px;
    padding: 12px 16px; margin-bottom: 14px;
}
.tardios-faixa-icone { font-size: 1.1rem; line-height: 1.4; }
.tardios-faixa-texto { flex: 1 1; font-size: 0.84rem; color: #7c2d12; line-height: 1.55; }
.tardios-faixa-btn {
    align-self: center; white-space: nowrap;
    background: #ea580c; color: #fff; border: none; border-radius: 7px;
    padding: 7px 14px; font-size: 0.8rem; font-weight: 700; cursor: pointer;
}
.tardios-faixa-btn:hover { background: #c2410c; }


/* "Atualizar reconciliacoes": manda o reconciliador associar os movimentos que
   ja tem fatura lancada aqui. Azul e nao verde porque nao e o gemeo do "ja
   tratei" — este mexe no documento do contabilista, aquele so arruma a lista. */
.tardios-btn-atualizar {
    margin-left: 8px; white-space: nowrap;
    background: #fff; color: #1d4ed8; border: 1px solid #93c5fd;
    border-radius: 6px; padding: 4px 10px;
    font-size: 0.75rem; font-weight: 700; cursor: pointer;
}
.tardios-btn-atualizar:hover:not(:disabled) { background: #dbeafe; }
.tardios-btn-atualizar:disabled { opacity: 0.55; cursor: default; }

/* A barra ocupa a largura toda, como a caixa de filtros por baixo. O
   .shared-subnav geral tem width: fit-content, que a encolhia ao conteúdo e não
   deixava os botões crescerem. Preso a esta barra, para não mexer nas outras
   páginas que usam a mesma classe. */
.shared-subnav.subnav-reconciliador { width: 100%; box-sizing: border-box; }

/* Separadores em três andares: ícone em cima, e o título nas duas linhas por
   baixo. Sem coluna para o ícone, cada botão fica com a largura do seu texto.

   As medidas não são a olho: com o texto a 12px e 10px de margem lateral, os
   nove somam ~865px (folgas incluídas) e cabem nos ~1050px úteis. Eram dez e
   somavam ~970px — "Faturas s/ extrato" saiu e a fila ficou com mais folga; o
   corpo mantém-se nos 12px porque é o que deixa lugar a um separador novo sem
   a fila passar a duas linhas. */
.subnav-btn-duplo {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    row-gap: 1px;
    line-height: 1.2;
    white-space: nowrap;
    text-align: center;
    padding: 6px 10px;

    /* Todos com a mesma largura: crescem em partes iguais para encher a fila e
       nunca encolhem abaixo dos 113px, que é o que a palavra mais larga —
       "RECONCILIADOS", 93px a 12px de letra — precisa com as margens. Nove a
       113px dão 1017px, e com as folgas entre botões ~1055px; numa fila mais
       estreita do que isso, desliza. */
    flex: 1 0 113px;
    min-width: 0;
}
.subnav-btn-duplo .subnav-icone {
    font-size: 19px;
    line-height: 1;
    margin-bottom: 11px;   /* afasta o título do ícone */
}
/* Separador de uma palavra só: ocupa a altura das duas linhas e fica a meio. */
.subnav-btn-duplo .subnav-unico {
    min-height: 2.4em;
    display: flex;
    align-items: center;
}
/* As duas linhas de texto declaradas com os mesmos valores, em vez de contarem
   com o que herdam: assim ficam iguais mesmo que outra folha de estilos mexa no
   botão — e o tema "simple", por exemplo, mexe. */
.subnav-btn-duplo > span:not(.subnav-icone) {
    font-family: inherit;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: .01em;
    line-height: 1.2;
}
body[data-page-theme="simple"] .subnav-btn-duplo > span:not(.subnav-icone) {
    font-size: 12px;
    font-weight: 400;
}


/* Gasto do mês e cartões sem extrato.
   O número só é fiável quando todos os cartões têm extrato; quando não tem,
   diz-se, em vez de mostrar um total curto como se fosse o certo. */
.summary-item.gasto-mes .summary-value { color: #0f172a; }


.aviso-sem-extrato {
    display: flex; gap: 12px; align-items: flex-start;
    background: #fffbeb; border: 1px solid #fcd34d; border-radius: 8px;
    padding: 12px 14px; margin-bottom: 16px;
}
.aviso-sem-extrato .aviso-icone { font-size: 18px; line-height: 1.2; flex: 0 0 auto; }
.aviso-sem-extrato strong { display: block; color: #92400e; font-size: 14px; }
.aviso-sem-extrato .aviso-detalhe {
    display: block; color: #a16207; font-size: 12.5px; margin-top: 2px;
}
.aviso-sem-extrato .aviso-lista {
    margin: 8px 0 0; padding-left: 18px; color: #78350f; font-size: 12.5px;
    columns: 2; column-gap: 26px;
}
.aviso-sem-extrato .aviso-lista li { margin-bottom: 2px; break-inside: avoid; }
.aviso-sem-extrato .aviso-digitos {
    color: #a16207; font-variant-numeric: tabular-nums; margin-left: 4px;
}
@media (max-width: 720px) { .aviso-sem-extrato .aviso-lista { columns: 1; } }


/* Sem um único extrato do mês não há valor a mostrar. Fica texto, e em corpo
   mais pequeno, para não ocupar o lugar de um número que não existe. */
.summary-item.gasto-mes .sem-extratos {
    font-size: 0.62em; font-weight: 600; letter-spacing: 0.2px;
    text-transform: uppercase; color: #b45309; white-space: nowrap;
}


/* ---- Barra de resumo: títulos e valores todos iguais e ao centro ----
   Antes cada número tinha o seu tamanho e o seu alinhamento, e a barra lia-se
   como três coisas soltas em vez de três colunas comparáveis. */
.summary-bar .summary-item {
    align-items: center;
    text-align: center;
    justify-content: flex-start;
}
.summary-bar .summary-label {
    font-size: 0.85rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    margin-bottom: 4px;
}
.summary-bar .summary-value {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 1.35rem;
    font-weight: 700;
    line-height: 1.25;
    font-variant-numeric: tabular-nums;
}
/* A segunda linha de um valor (o montante, por baixo da contagem) é do mesmo
   tamanho: são dois registos, não um registo e uma legenda. */
.summary-bar .summary-sub {
    font-size: 1em;
    font-weight: 700;
    line-height: 1.25;
}
/* Excepção assumida: aqui não há número nenhum, há uma frase. Ao tamanho dos
   números ocuparia meia barra. */
.summary-item.gasto-mes .sem-extratos {
    font-size: 0.55em; letter-spacing: 0.2px;
}


/* ---- Barra de resumo, versão final ----
   Três colunas comparáveis: mesmo título, mesmo valor, mesma cor. Antes cada
   uma tinha a sua cor e o seu peso, e a cor lia-se como significado quando era
   só decoração. O que assinala uma pendência é o ⚠️ e o texto, não o tom. */
.summary-bar { align-items: stretch; }

.summary-bar .summary-item {
    align-items: center;
    justify-content: center;      /* ao centro do centro, também na vertical */
    text-align: center;
}
.summary-bar .summary-label {
    font-size: 0.95rem;
    font-weight: 700;
    color: #475569;
    letter-spacing: 0.03em;
    margin-bottom: 5px;
}
.summary-bar .summary-value,
.summary-bar .summary-sub,
.summary-item.gasto-mes .sem-extratos {
    font-size: 1.15rem;
    font-weight: 500;             /* sem negrito, como pedido */
    color: #334155;
    line-height: 1.3;
    letter-spacing: normal;
    text-transform: none;
}
.summary-bar .summary-value { font-variant-numeric: tabular-nums; }
/* A cor de alerta sai dos números: quem avisa é o ⚠️ e o texto. */
.summary-item.gasto-mes.incompleto .summary-label,
.summary-item.gasto-mes.incompleto .summary-value,
.summary-item.gasto-mes .summary-value { color: #334155; }


/* ---- Barra de resumo: títulos em destaque, valores discretos ----
   A hierarquia inverte-se de propósito: o título é a etiqueta que se procura,
   o número é o que se lê depois de a ter encontrado. #3182ce é o azul que a
   aplicação já usa como cor de destaque, não é um tom novo. */
.summary-bar .summary-label {
    color: #3182ce;
    white-space: nowrap;          /* "Revolut sem fatura" numa linha só */
}


.summary-bar .summary-value,
.summary-bar .summary-sub,
.summary-item.gasto-mes .sem-extratos {
    font-size: 0.65rem;           /* 1,15rem - 0,5 */
}


/* ---- Barra de resumo: acertos finais ----
   Os títulos passam a encostar ao topo. Estavam centrados na vertical, e como
   as colunas têm alturas diferentes (uma tem o valor em duas linhas, outra em
   uma), o centro de cada uma caía a alturas diferentes e o "FATURAS" descaía
   em relação aos vizinhos. Encostando ao topo, os três ficam na mesma linha. */
.summary-bar .summary-item { justify-content: flex-start; }

.summary-bar .summary-label,
.summary-item.gasto-mes.incompleto .summary-label { color: #991b1b; }


/* Os valores voltam a subir, para o mesmo corpo dos títulos: distinguem-se
   pelo peso e pela cor, já não precisam de se distinguir pelo tamanho. */
.summary-bar .summary-value,
.summary-bar .summary-sub,
.summary-item.gasto-mes .sem-extratos {
    font-size: 0.95rem;
}


/* Títulos maiores. Continuam com quebra de linha proibida, por isso a barra
   alarga em vez de os partir em duas linhas. */
.summary-bar .summary-label { font-size: 1.1rem; }


/* Valores ao mesmo corpo dos títulos: distinguem-se pelo peso e pela cor. */
.summary-bar .summary-value,
.summary-bar .summary-sub,
.summary-item.gasto-mes .sem-extratos {
    font-size: 1.1rem;
}


/* ---- Filtros de coluna da lista de despesas ---- */
.filtro-col { position: relative; display: inline-block; margin-left: 5px; }
.filtro-col-btn {
    border: none; background: none; cursor: pointer; padding: 0 2px;
    font-size: 0.6rem; color: #94a3b8; line-height: 1; vertical-align: middle;
}
.filtro-col-btn:hover { color: #3182ce; }
.filtro-col-btn.ativo { color: #3182ce; font-weight: 700; }
.filtro-col-conta {
    display: inline-block; margin-left: 3px; padding: 0 4px; border-radius: 8px;
    background: #3182ce; color: #fff; font-size: 0.58rem; line-height: 1.5;
}
.filtro-col-painel {
    position: absolute; top: calc(100% + 6px); left: 0; z-index: 60;
    width: 260px; background: #fff; border: 1px solid #e2e8f0; border-radius: 8px;
    box-shadow: 0 8px 24px rgba(15, 23, 42, 0.16);
    padding: 8px; display: flex; flex-direction: column; gap: 6px;
    text-transform: none; letter-spacing: normal; font-weight: 400;
}
.filtro-col-busca {
    padding: 5px 8px; border: 1px solid #e2e8f0; border-radius: 6px;
    font-size: 12px; font-family: inherit; color: #374151;
}
.filtro-col-busca:focus { border-color: #3b82f6; outline: none; }
.filtro-col-acoes { display: flex; gap: 6px; }
.filtro-col-acoes button {
    flex: 1 1; padding: 4px 6px; border-radius: 5px; font-size: 11px;
    background: #f8fafc; color: #475569; border: 1px solid #e2e8f0;
    cursor: pointer; font-family: inherit;
}
.filtro-col-acoes button:hover { background: #f1f5f9; }
.filtro-col-lista { max-height: 240px; overflow-y: auto; overscroll-behavior: contain; }
.filtro-col-item {
    display: flex; align-items: flex-start; gap: 7px; padding: 4px 5px;
    border-radius: 5px; font-size: 12px; color: #374151; cursor: pointer;
    line-height: 1.35; text-align: left;
}
.filtro-col-item:hover { background: #f8fafc; }
.filtro-col-item input { margin-top: 2px; flex: 0 0 auto; cursor: pointer; }
.filtro-col-vazio { margin: 0; padding: 6px 5px; font-size: 11px; color: #94a3b8; }

/* O cabeçalho da tabela tem de deixar o painel sair para fora da célula. */
.despesas-table thead th { overflow: visible; position: relative; }
.table-container { overflow: visible !important; }

.btn-limpar-filtros {
    padding: 3px 10px; border-radius: 6px; font-size: 0.8rem; font-family: inherit;
    background: #fff; color: #991b1b; border: 1px solid #991b1b; cursor: pointer;
}
.btn-limpar-filtros:hover { background: #fef2f2; }


/* ---- Ordenação por coluna ---- */
.despesas-table thead th .th-ordenavel {
    cursor: pointer; user-select: none; display: inline-flex;
    align-items: center; gap: 4px;
}
.despesas-table thead th .th-ordenavel:hover { color: #3182ce; }
.th-seta { font-size: 0.62rem; color: #cbd5e1; line-height: 1; }
.th-seta.ativa { color: #3182ce; }


/* Sete colunas não cabem numa linha em todos os ecrãs: a barra quebra em vez
   de encolher os números até ficarem ilegíveis. */
.summary-bar.compact { flex-wrap: wrap; gap: 14px 26px; row-gap: 12px; }
.summary-bar .summary-item { min-width: 92px; }


/* As sete colunas repartem a barra em partes iguais. O título ocupa sempre a
   altura de duas linhas — mesmo o que só tem uma — para os valores de todas as
   colunas ficarem à mesma altura. */
.summary-bar.compact .summary-item {
    flex: 1 1;
    min-width: 118px;
}
.summary-bar .summary-label {
    min-height: 2.6em;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    line-height: 1.3;
}


/* Marca de valor parcial, no mês que ainda não fechou. */
.summary-bar .summary-sub.parcial {
    font-size: 12px !important; font-weight: 600; color: #b45309; text-transform: uppercase;
    letter-spacing: 0.3px;
    margin-top: 6px;
}

/* Resultado explícito comum ao QR Code e ao registo manual. */
.despesa-resultado-overlay { position: fixed; inset: 0; z-index: 20000 !important; display: flex; align-items: center; justify-content: center; background: #14253699; padding: 16px; }
.despesa-resultado { background: white; color: #294b69; border-radius: 14px; padding: 24px; width: min(100%, 460px); max-height: 90vh; overflow: auto; box-sizing: border-box; border-top: 5px solid #d69e2e; }
.despesa-resultado-sucesso { border-top-color: #239469; }
.despesa-resultado-erro { border-top-color: #c53030; }
.despesa-resultado h2 { font-size: 20px; margin: 0 0 14px; }
.despesa-resultado p { font-size: 14px; line-height: 1.5; }
.despesa-resultado dl { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; background: #f1f7fc; padding: 14px; border-radius: 8px; }
.despesa-resultado dd { margin: 0; font-weight: 600; }
.despesa-resultado .btn-scan { width: 100%; margin-top: 12px; }
.despesa-resultado-aviso { color: #975a16; }
`, "",{"version":3,"sources":["webpack://./src/pages/Despesas.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,6CAA6C;IAC7C,mBAAmB;IACnB,aAAa;IACb,SAAS;IACT,qBAAqB;IACrB,eAAe;AACnB;;AAEA;;kFAEkF;AAClF;IACI,oBAAoB;IACpB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;AACA,8BAA8B,cAAc,EAAE,gBAAgB,EAAE;;AAEhE;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;;IAEI,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,sBAAsB;IACtB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;;IAEI,aAAa;IACb,qBAAqB;IACrB,6CAA6C;AACjD;;;AAGA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,aAAa;IACb,SAAS;IACT,yBAAyB;IACzB,yCAAyC;AAC7C;;AAEA;IACI,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI;QACI,eAAe;QACf,gDAAgD;IACpD;AACJ;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA,mBAAmB;AACnB;IACI,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;;sCAEsC;;AAEtC;IACI,uBAAuB;IACvB,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,oBAAoB;IACpB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;IAEI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA,wBAAwB;AACxB;IACI,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;;;wDAGwD;AACxD;IACI,aAAa;IACb,gBAAgB;IAChB,cAAc;IACd,+BAA+B;IAC/B,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,8BAA8B;IAC9B,kBAAkB;IAClB,WAAW;IACX,mCAAmC;AACvC;;AAEA;IACI;QACI,aAAa;QACb,iBAAiB;QACjB,8BAA8B;QAC9B,yDAAyD;QACzD,2BAA2B;IAC/B;AACJ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,0BAA0B;IAC1B,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;;AAGA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,yCAAyC;AAC7C;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;;AAGA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,0BAA0B;IAC1B,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI;QACI,wBAAwB;IAC5B;;IAEA;;4EAEwE;IACxE;QACI,wBAAwB;IAC5B;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,aAAa;QACb,QAAQ;IACZ;;IAEA;;;mEAG+D;IAC/D;QACI,YAAY;QACZ,eAAe;QACf,uBAAuB;IAC3B;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA,wFAAwF;AACxF;IACI,sBAAsB;IACtB,uBAAuB;IACvB,sBAAsB;IACtB,4BAA4B;IAC5B,oCAAoC;IACpC,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;IACrB,4BAA4B;IAC5B,oCAAoC;IACpC,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,oBAAoB;IACpB,6BAA6B;IAC7B,oCAAoC;IACpC,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,6BAA6B;IAC7B,oCAAoC;IACpC,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;IACrB,uBAAuB;IACvB,oCAAoC;IACpC,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,qBAAqB;IACrB,sBAAsB;IACtB,oCAAoC;IACpC,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,wBAAwB;IACxB,uBAAuB;IACvB,oCAAoC;IACpC,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,wBAAwB;IACxB,sBAAsB;IACtB,oCAAoC;IACpC,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;AAC3B;;AAEA;IACI,sDAAsD;AAC1D;;AAEA;IACI,iDAAiD;AACrD;;AAEA,wBAAwB;AACxB;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,YAAY;IAChB;;IAEA;QACI,qBAAqB;QACrB,UAAU;IACd;;IAEA;QACI,qBAAqB;QACrB,UAAU;IACd;AACJ;AACA;;;wBAGwB;AACxB,gBAAgB,mBAAmB,EAAE;AACrC;IACI,aAAa,EAAE,8BAA8B,EAAE,uBAAuB;IACtE,SAAS,EAAE,eAAe,EAAE,mBAAmB;AACnD;AACA,qBAAqB,eAAe,EAAE,kBAAkB,EAAE,cAAc,EAAE;AAC1E,oBAAoB,SAAS,EAAE,kBAAkB,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACrF,mBAAmB,aAAa,EAAE,SAAS,EAAE,mBAAmB,EAAE,eAAe,EAAE;AACnF;IACI,aAAa,EAAE,mBAAmB,EAAE,QAAQ;IAC5C,kBAAkB,EAAE,gBAAgB,EAAE,cAAc;IACpD,gBAAgB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,iBAAiB;AACtF;AACA;IACI,yBAAyB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,kBAAkB;AACvF;AACA,wCAAwC,WAAW,EAAE,kBAAkB,EAAE;;AAEzE,gBAAgB,kBAAkB,EAAE,cAAc,EAAE,eAAe,EAAE;AACrE,cAAc,cAAc,EAAE,gBAAgB,EAAE;AAChD;IACI,kBAAkB,EAAE,cAAc,EAAE,mBAAmB;IACvD,yBAAyB,EAAE,kBAAkB,EAAE,kBAAkB;AACrE;;AAEA,iBAAiB,mBAAmB,EAAE;AACtC;IACI,aAAa,EAAE,mBAAmB,EAAE,SAAS;IAC7C,kBAAkB,EAAE,gBAAgB,EAAE,cAAc;IACpD,mBAAmB,EAAE,yBAAyB;IAC9C,0BAA0B,EAAE,iBAAiB;AACjD;AACA,uBAAuB,iBAAiB,EAAE,kCAAkC,EAAE;AAC9E,kBAAkB,WAAW,EAAE,yBAAyB,EAAE,kBAAkB,EAAE;AAC9E;IACI,mBAAmB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,kBAAkB;IAC3E,yBAAyB,EAAE,qBAAqB,EAAE,cAAc;IAChE,iBAAiB,EAAE,gCAAgC;AACvD;AACA,qBAAqB,iBAAiB,EAAE,gCAAgC,EAAE,cAAc,EAAE;AAC1F,8DAA8D;AAC9D,iBAAiB,gBAAgB,EAAE,cAAc,EAAE;;AAEnD,wCAAwC;AACxC;IACI,aAAa,EAAE,uBAAuB,EAAE,SAAS;IACjD,mBAAmB,EAAE,yBAAyB,EAAE,mBAAmB;IACnE,kBAAkB,EAAE,mBAAmB;AAC3C;AACA,uBAAuB,iBAAiB,EAAE,gBAAgB,EAAE;AAC5D,uBAAuB,SAAO,EAAE,kBAAkB,EAAE,cAAc,EAAE,iBAAiB,EAAE;AACvF;IACI,kBAAkB,EAAE,mBAAmB;IACvC,mBAAmB,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB;IAClE,iBAAiB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,eAAe;AAC3E;AACA,2BAA2B,mBAAmB,EAAE;;;AAGhD;;gFAEgF;AAChF;IACI,gBAAgB,EAAE,mBAAmB;IACrC,gBAAgB,EAAE,cAAc,EAAE,yBAAyB;IAC3D,kBAAkB,EAAE,iBAAiB;IACrC,kBAAkB,EAAE,gBAAgB,EAAE,eAAe;AACzD;AACA,8CAA8C,mBAAmB,EAAE;AACnE,kCAAkC,aAAa,EAAE,eAAe,EAAE;;AAElE;;;qCAGqC;AACrC,sCAAsC,WAAW,EAAE,sBAAsB,EAAE;;AAE3E;;;;;;;iCAOiC;AACjC;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;;IAEjB;;;;uCAImC;IACnC,eAAe;IACf,YAAY;AAChB;AACA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB,IAAI,6BAA6B;AACxD;AACA,+EAA+E;AAC/E;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;AACvB;AACA;;kDAEkD;AAClD;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;;;AAGA;;oEAEoE;AACpE,yCAAyC,cAAc,EAAE;;;AAGzD;IACI,aAAa,EAAE,SAAS,EAAE,uBAAuB;IACjD,mBAAmB,EAAE,yBAAyB,EAAE,kBAAkB;IAClE,kBAAkB,EAAE,mBAAmB;AAC3C;AACA,kCAAkC,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACrF,4BAA4B,cAAc,EAAE,cAAc,EAAE,eAAe,EAAE;AAC7E;IACI,cAAc,EAAE,cAAc,EAAE,iBAAiB,EAAE,eAAe;AACtE;AACA;IACI,eAAe,EAAE,kBAAkB,EAAE,cAAc,EAAE,iBAAiB;IACtE,UAAU,EAAE,gBAAgB;AAChC;AACA,qCAAqC,kBAAkB,EAAE,mBAAmB,EAAE;AAC9E;IACI,cAAc,EAAE,kCAAkC,EAAE,gBAAgB;AACxE;AACA,4BAA4B,kCAAkC,UAAU,EAAE,EAAE;;;AAG5E;uEACuE;AACvE;IACI,iBAAiB,EAAE,gBAAgB,EAAE,qBAAqB;IAC1D,yBAAyB,EAAE,cAAc,EAAE,mBAAmB;AAClE;;;AAGA;;gEAEgE;AAChE;IACI,mBAAmB;IACnB,kBAAkB;IAClB,2BAA2B;AAC/B;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,kCAAkC;AACtC;AACA;8DAC8D;AAC9D;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;AACA;iCACiC;AACjC;IACI,iBAAiB,EAAE,qBAAqB;AAC5C;;;AAGA;;;4EAG4E;AAC5E,eAAe,oBAAoB,EAAE;;AAErC;IACI,mBAAmB;IACnB,uBAAuB,OAAO,4CAA4C;IAC1E,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,kBAAkB;AACtB;AACA;;;IAGI,kBAAkB;IAClB,gBAAgB,cAAc,6BAA6B;IAC3D,cAAc;IACd,gBAAgB;IAChB,sBAAsB;IACtB,oBAAoB;AACxB;AACA,8BAA8B,kCAAkC,EAAE;AAClE,kEAAkE;AAClE;;yCAEyC,cAAc,EAAE;;;AAGzD;;;8DAG8D;AAC9D;IACI,cAAc;IACd,mBAAmB,WAAW,uCAAuC;AACzE;;;AAGA;;;IAGI,kBAAkB,YAAY,kBAAkB;AACpD;;;AAGA;;;;+EAI+E;AAC/E,6BAA6B,2BAA2B,EAAE;;AAE1D;oDACoD,cAAc,EAAE;;;AAGpE;yEACyE;AACzE;;;IAGI,kBAAkB;AACtB;;;AAGA;+CAC+C;AAC/C,8BAA8B,iBAAiB,EAAE;;;AAGjD,4EAA4E;AAC5E;;;IAGI,iBAAiB;AACrB;;;AAGA,qDAAqD;AACrD,cAAc,kBAAkB,EAAE,qBAAqB,EAAE,gBAAgB,EAAE;AAC3E;IACI,YAAY,EAAE,gBAAgB,EAAE,eAAe,EAAE,cAAc;IAC/D,iBAAiB,EAAE,cAAc,EAAE,cAAc,EAAE,sBAAsB;AAC7E;AACA,wBAAwB,cAAc,EAAE;AACxC,wBAAwB,cAAc,EAAE,gBAAgB,EAAE;AAC1D;IACI,qBAAqB,EAAE,gBAAgB,EAAE,cAAc,EAAE,kBAAkB;IAC3E,mBAAmB,EAAE,WAAW,EAAE,kBAAkB,EAAE,gBAAgB;AAC1E;AACA;IACI,kBAAkB,EAAE,qBAAqB,EAAE,OAAO,EAAE,WAAW;IAC/D,YAAY,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,kBAAkB;IAC7E,6CAA6C;IAC7C,YAAY,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ;IAC7D,oBAAoB,EAAE,sBAAsB,EAAE,gBAAgB;AAClE;AACA;IACI,gBAAgB,EAAE,yBAAyB,EAAE,kBAAkB;IAC/D,eAAe,EAAE,oBAAoB,EAAE,cAAc;AACzD;AACA,0BAA0B,qBAAqB,EAAE,aAAa,EAAE;AAChE,oBAAoB,aAAa,EAAE,QAAQ,EAAE;AAC7C;IACI,SAAO,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,eAAe;IAC9D,mBAAmB,EAAE,cAAc,EAAE,yBAAyB;IAC9D,eAAe,EAAE,oBAAoB;AACzC;AACA,iCAAiC,mBAAmB,EAAE;AACtD,oBAAoB,iBAAiB,EAAE,gBAAgB,EAAE,4BAA4B,EAAE;AACvF;IACI,aAAa,EAAE,uBAAuB,EAAE,QAAQ,EAAE,gBAAgB;IAClE,kBAAkB,EAAE,eAAe,EAAE,cAAc,EAAE,eAAe;IACpE,iBAAiB,EAAE,gBAAgB;AACvC;AACA,yBAAyB,mBAAmB,EAAE;AAC9C,yBAAyB,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE;AAC3E,oBAAoB,SAAS,EAAE,gBAAgB,EAAE,eAAe,EAAE,cAAc,EAAE;;AAElF,2EAA2E;AAC3E,2BAA2B,iBAAiB,EAAE,kBAAkB,EAAE;AAClE,mBAAmB,4BAA4B,EAAE;;AAEjD;IACI,iBAAiB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,oBAAoB;IAC9E,gBAAgB,EAAE,cAAc,EAAE,yBAAyB,EAAE,eAAe;AAChF;AACA,4BAA4B,mBAAmB,EAAE;;;AAGjD,mCAAmC;AACnC;IACI,eAAe,EAAE,iBAAiB,EAAE,oBAAoB;IACxD,mBAAmB,EAAE,QAAQ;AACjC;AACA,+CAA+C,cAAc,EAAE;AAC/D,WAAW,kBAAkB,EAAE,cAAc,EAAE,cAAc,EAAE;AAC/D,iBAAiB,cAAc,EAAE;;;AAGjC;kDACkD;AAClD,uBAAuB,eAAe,EAAE,cAAc,EAAE,aAAa,EAAE;AACvE,6BAA6B,eAAe,EAAE;;;AAG9C;;oCAEoC;AACpC;IACI,SAAW;IACX,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,gBAAgB;AACpB;;;AAGA,yDAAyD;AACzD;IACI,0BAA0B,EAAE,gBAAgB,EAAE,cAAc,EAAE,yBAAyB;IACvF,qBAAqB;IACrB,eAAe;AACnB;;AAEA,8DAA8D;AAC9D,6BAA6B,eAAe,EAAE,QAAQ,EAAE,yBAAyB,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,qBAAqB,EAAE,aAAa,EAAE;AACtL,qBAAqB,iBAAiB,EAAE,cAAc,EAAE,mBAAmB,EAAE,aAAa,EAAE,uBAAuB,EAAE,gBAAgB,EAAE,cAAc,EAAE,sBAAsB,EAAE,6BAA6B,EAAE;AAC9M,6BAA6B,yBAAyB,EAAE;AACxD,0BAA0B,yBAAyB,EAAE;AACrD,wBAAwB,eAAe,EAAE,gBAAgB,EAAE;AAC3D,uBAAuB,eAAe,EAAE,gBAAgB,EAAE;AAC1D,wBAAwB,aAAa,EAAE,8BAA8B,EAAE,SAAS,EAAE,mBAAmB,EAAE,aAAa,EAAE,kBAAkB,EAAE;AAC1I,wBAAwB,SAAS,EAAE,gBAAgB,EAAE;AACrD,+BAA+B,WAAW,EAAE,gBAAgB,EAAE;AAC9D,2BAA2B,cAAc,EAAE","sourcesContent":[".despesas-page {\n    display: flex;\n    flex-direction: column;\n    min-height: 100vh;\n}\n\n.filters-bar {\n    background: white;\n    padding: 24px;\n    border-radius: 12px;\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n    margin-bottom: 24px;\n    display: flex;\n    gap: 20px;\n    align-items: flex-end;\n    flex-wrap: wrap;\n}\n\n/* O alcance da exportação, escrito por baixo da caixa de filtros. Estava só no\n   title dos botões, que no telemóvel não aparece — e é no telemóvel que a caixa\n   de filtros continua desenhada enquanto a tabela com os filtros de coluna não. */\n.export-nota-alcance {\n    margin: -16px 0 20px;\n    padding: 0 4px;\n    font-size: 0.82rem;\n    line-height: 1.5;\n    color: #4a5568;\n}\n.export-nota-alcance strong { color: #2d3748; font-weight: 600; }\n\n.filter-group {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.filter-group label {\n    font-size: 0.75rem;\n    font-weight: 600;\n    color: #718096;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n}\n\n.filter-group select,\n.filter-group input {\n    padding: 10px 14px;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    font-size: 0.95rem;\n    color: #2d3748;\n    background-color: #fff;\n    min-width: 140px;\n    transition: all 0.2s;\n}\n\n.filter-group select:focus,\n.filter-group input:focus {\n    outline: none;\n    border-color: #4299e1;\n    box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.1);\n}\n\n\n.summary-bar {\n    background: white;\n    border-radius: 12px;\n    padding: 10px 20px;\n    /* Reduced padding */\n    margin-bottom: 24px;\n    display: flex;\n    gap: 40px;\n    border: 1px solid #e2e8f0;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);\n}\n\n.summary-bar.compact {\n    padding: 8px 16px;\n    gap: 30px;\n}\n\n.summary-item {\n    display: flex;\n    flex-direction: column;\n}\n\n.summary-label {\n    font-size: 0.7rem;\n    /* Smaller font */\n    color: #718096;\n    text-transform: uppercase;\n    font-weight: 600;\n    letter-spacing: 0.05em;\n    margin-bottom: 2px;\n}\n\n.summary-value {\n    font-size: 1.25rem;\n    /* Smaller value */\n    color: #2d3748;\n    font-weight: 700;\n    line-height: 1.2;\n}\n\n.export-btn {\n    display: flex;\n    align-items: center;\n    line-height: 1.2;\n}\n\n.export-btn {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 10px 20px;\n    border-radius: 8px;\n    font-size: 0.95rem;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s;\n    border: 1px solid #e2e8f0;\n    background: white;\n}\n\n.export-btn.large {\n    padding: 12px 24px;\n    font-size: 1rem;\n    color: #4a5568;\n}\n\n.export-btn:hover {\n    background: #f7fafc;\n    border-color: #cbd5e0;\n}\n\n.export-actions {\n    display: flex;\n    gap: 10px;\n    align-items: center;\n}\n\n@media (max-width: 768px) {\n    .despesas-page .page-content {\n        padding: 0 15px;\n        /* Restore side padding, keep top/bottom tight */\n    }\n}\n\n.manual-active {\n    border-style: solid;\n    border-color: #ed8936;\n    background: #fffaf0;\n}\n\n/* Scanner Styles */\n#reader {\n    width: 100% !important;\n    border-radius: 12px;\n    overflow: hidden;\n}\n\n/* A vista em mosaicos foi retirada: era a tabela sem estado, sem\n   miniatura e sem quem lançou, e abria o detalhe errado num movimento\n   Revolut. O CSS dela saiu com ela. */\n\n.action-btn {\n    background: transparent;\n    border: 1px solid #e2e8f0;\n    width: 32px;\n    height: 32px;\n    border-radius: 6px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: all 0.2s;\n    font-size: 1rem;\n}\n\n.action-btn:hover {\n    background: #ebf8ff;\n    border-color: #3182ce;\n}\n\n.action-btn-delete {\n    background: transparent;\n    border: 1px solid #fed7d7;\n    width: 32px;\n    height: 32px;\n    border-radius: 6px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: all 0.2s;\n    font-size: 1rem;\n    color: #e53e3e;\n}\n\n.action-btn-delete:hover {\n    background: #fff5f5;\n    border-color: #e53e3e;\n}\n\n.btn-cancel-manual {\n    background: #fed7d7;\n    color: #c53030;\n    border: none;\n    padding: 12px 24px;\n    border-radius: 10px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background 0.2s;\n}\n\n.btn-cancel-manual:hover {\n    background: #feb2b2;\n}\n\n.btn-scan {\n    background: #3182ce;\n    color: white;\n    border: none;\n    padding: 12px 24px;\n    border-radius: 10px;\n    font-weight: 600;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    cursor: pointer;\n    transition: background 0.2s;\n}\n\n.btn-scan:hover {\n    background: #2b6cb0;\n}\n\n.form-group {\n    margin-bottom: 20px;\n}\n\n.form-group label {\n    display: block;\n    margin-bottom: 8px;\n    font-weight: 600;\n    color: #4a5568;\n}\n\n.form-group input,\n.form-group select {\n    width: 100%;\n    padding: 12px;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    font-size: 1rem;\n}\n\n.preview-photo {\n    width: 100%;\n    max-height: 300px;\n    object-fit: contain;\n    background: #f7fafc;\n    border-radius: 12px;\n}\n\n.despesas-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 0.9rem;\n}\n\n.despesas-table th {\n    background: #f8fafc;\n    padding: 10px 16px;\n    text-align: left;\n    font-size: 0.7rem;\n    font-weight: 600;\n    color: #64748b;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    border-bottom: 2px solid #edf2f7;\n}\n\n.despesas-table td {\n    padding: 12px 16px;\n    /* Slightly tighter */\n    border-bottom: 1px solid #edf2f7;\n    color: #2d3748;\n}\n\n.despesas-table tr:last-child td {\n    border-bottom: none;\n}\n\n.despesas-table tr:hover td {\n    background-color: #f7fafc;\n}\n\n\n.valor-cel {\n    font-weight: 700;\n    color: #2b6cb0;\n    font-size: 1.05rem;\n}\n\n/* Capture View Styles */\n.capture-mode-active .top-bar {\n    background: #f8fafc;\n    border-bottom: 1px solid #e2e8f0;\n}\n\n/* Ecrã de registo. Esteve definido quatro vezes, com o primeiro par a\n   contradizer o segundo em justify-content e min-height — e o comentário do\n   primeiro a descrever um efeito que nunca se via. Ficam duas definições, com\n   o resultado idêntico ao que estava a ser desenhado. */\n.capture-view {\n    padding: 20px;\n    max-width: 600px;\n    margin: 0 auto;\n    animation: fadeIn 0.3s ease-out;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    min-height: calc(100vh - 80px);\n    overflow-x: hidden;\n    width: 100%;\n    /* Adjust based on top bar height */\n}\n\n@media (max-width: 768px) {\n    .capture-view {\n        padding: 10px;\n        padding-top: 10px;\n        min-height: calc(100vh - 60px);\n        /* No telemóvel o conteúdo assenta em cima, não a meio. */\n        justify-content: flex-start;\n    }\n}\n\n.capture-hero {\n    margin-bottom: 30px;\n}\n\n.capture-main-card {\n    background: white;\n    border: 3px dashed #3182ce;\n    border-radius: 20px;\n    padding: 26px 20px;\n    text-align: center;\n    cursor: pointer;\n    transition: all 0.2s;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 12px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);\n}\n\n.capture-main-card:hover {\n    background: #ebf8ff;\n    border-color: #2b6cb0;\n    transform: translateY(-5px);\n}\n\n.camera-icon-wrapper {\n    position: relative;\n    width: 68px;\n    height: 68px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #3182ce;\n    border-radius: 50%;\n    color: white;\n}\n\n.camera-emoji {\n    font-size: 40px;\n    z-index: 2;\n}\n\n.camera-ring {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    border: 4px solid #3182ce;\n    border-radius: 50%;\n    animation: pulse 2s infinite;\n}\n\n.capture-text h2 {\n    margin: 0;\n    color: #2d3748;\n}\n\n.capture-text p {\n    margin: 5px 0 0;\n    color: #718096;\n    font-size: 0.95rem;\n}\n\n\n.default-card-selector {\n    margin-bottom: 20px;\n    background: white;\n    padding: 15px;\n    border-radius: 12px;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);\n}\n\n.default-card-selector label {\n    display: block;\n    margin-bottom: 8px;\n    font-weight: 600;\n    color: #4a5568;\n    font-size: 0.9rem;\n}\n\n.card-dropdown {\n    width: 100%;\n    padding: 10px;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    font-size: 1rem;\n    color: #2d3748;\n    background: #f8fafc;\n}\n\n.recent-entries-section {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n}\n\n\n.custom-camera-input {\n    width: 100%;\n    cursor: pointer;\n}\n\n.camera-preview-box {\n    width: 100%;\n    min-height: 150px;\n    background: #f7fafc;\n    border: 2px dashed #cbd5e0;\n    border-radius: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n}\n\n.camera-placeholder {\n    text-align: center;\n    color: #718096;\n}\n\n.camera-placeholder p {\n    margin-top: 10px;\n    font-weight: 600;\n}\n\n@media (max-width: 768px) {\n    .mobile-hide {\n        display: none !important;\n    }\n\n    /* No telemóvel/tablet a página das despesas fica como sempre foi: as secções\n       da reconciliação de extratos são ferramentas de secretária e não cabem\n       nesta largura. Vale também para quem entra com conta de escritório. */\n    .subnav-reconciliador {\n        display: none !important;\n    }\n\n    .mobile-only {\n        display: inline-block !important;\n    }\n\n    .top-bar-actions {\n        gap: 8px;\n    }\n\n    .export-actions.mobile-compact {\n        display: flex;\n        gap: 5px;\n    }\n\n    /* Atenção: hoje esta regra não pega em nenhum botão. Os quatro do ecrã das\n       despesas são .export-btn.large, que tem mais especificidade e ganha-lhe o\n       padding. O que impede os rótulos de apertarem a fila no telemóvel é serem\n       curtos lá (o \" do mês\" leva .mobile-hide), não esta regra. */\n    .export-btn {\n        padding: 8px;\n        min-width: 40px;\n        justify-content: center;\n    }\n\n    .filters-bar {\n        flex-direction: column;\n        align-items: stretch;\n    }\n\n    .filter-group select,\n    .filter-group input {\n        min-width: unset;\n    }\n\n    .despesas-table thead {\n        display: none;\n    }\n\n    .table-container {\n        overflow-x: auto;\n    }\n}\n\n/* Cropper.js - bigger handles for mobile touch (high specificity to override CDN CSS) */\n.cropper-crop-box .cropper-point.point-e {\n    width: 18px !important;\n    height: 36px !important;\n    right: -9px !important;\n    margin-top: -18px !important;\n    background-color: #3182ce !important;\n    border-radius: 9px !important;\n    opacity: 1 !important;\n}\n\n.cropper-crop-box .cropper-point.point-w {\n    width: 18px !important;\n    height: 36px !important;\n    left: -9px !important;\n    margin-top: -18px !important;\n    background-color: #3182ce !important;\n    border-radius: 9px !important;\n    opacity: 1 !important;\n}\n\n.cropper-crop-box .cropper-point.point-n {\n    width: 36px !important;\n    height: 18px !important;\n    top: -9px !important;\n    margin-left: -18px !important;\n    background-color: #3182ce !important;\n    border-radius: 9px !important;\n    opacity: 1 !important;\n}\n\n.cropper-crop-box .cropper-point.point-s {\n    width: 36px !important;\n    height: 18px !important;\n    bottom: -9px !important;\n    margin-left: -18px !important;\n    background-color: #3182ce !important;\n    border-radius: 9px !important;\n    opacity: 1 !important;\n}\n\n.cropper-crop-box .cropper-point.point-ne {\n    width: 28px !important;\n    height: 28px !important;\n    top: -14px !important;\n    right: -14px !important;\n    background-color: #3182ce !important;\n    border-radius: 50% !important;\n    opacity: 1 !important;\n}\n\n.cropper-crop-box .cropper-point.point-nw {\n    width: 28px !important;\n    height: 28px !important;\n    top: -14px !important;\n    left: -14px !important;\n    background-color: #3182ce !important;\n    border-radius: 50% !important;\n    opacity: 1 !important;\n}\n\n.cropper-crop-box .cropper-point.point-se {\n    width: 28px !important;\n    height: 28px !important;\n    bottom: -14px !important;\n    right: -14px !important;\n    background-color: #3182ce !important;\n    border-radius: 50% !important;\n    opacity: 1 !important;\n}\n\n.cropper-crop-box .cropper-point.point-sw {\n    width: 28px !important;\n    height: 28px !important;\n    bottom: -14px !important;\n    left: -14px !important;\n    background-color: #3182ce !important;\n    border-radius: 50% !important;\n    opacity: 1 !important;\n}\n\n.cropper-crop-box .cropper-line {\n    background-color: #3182ce !important;\n    opacity: 0.3 !important;\n}\n\n.cropper-crop-box .cropper-view-box {\n    outline: 2px solid rgba(49, 130, 206, 0.75) !important;\n}\n\n.cropper-crop-box .cropper-dashed {\n    border-color: rgba(255, 255, 255, 0.5) !important;\n}\n\n/* QR Code Preview Box */\n.qr-preview-box {\n    background: #ebf8ff;\n    border: 2px solid #bee3f8;\n    border-radius: 12px;\n    padding: 16px;\n    margin-bottom: 20px;\n}\n\n.qr-preview-header {\n    font-size: 0.8rem;\n    font-weight: 700;\n    color: #2b6cb0;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    margin-bottom: 12px;\n}\n\n.qr-preview-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 12px;\n}\n\n.qr-preview-item {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.qr-preview-label {\n    font-size: 0.75rem;\n    color: #718096;\n    font-weight: 600;\n}\n\n.qr-preview-value {\n    font-size: 1.1rem;\n    font-weight: 700;\n    color: #2d3748;\n    font-family: monospace;\n}\n\n.qr-preview-valor {\n    color: #2b6cb0;\n    font-size: 1.3rem;\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(10px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n@keyframes pulse {\n    0% {\n        transform: scale(1);\n        opacity: 0.8;\n    }\n\n    70% {\n        transform: scale(1.3);\n        opacity: 0;\n    }\n\n    100% {\n        transform: scale(1.3);\n        opacity: 0;\n    }\n}\n/* ---- Registos tardios ------------------------------------------------------\n   Vista que mostra o que foi carregado depois de o mes da fatura ja estar\n   fechado. Agrupada por mes da fatura: cada grupo e um mes cuja documentacao\n   tem de ser refeita. */\n.tardios-wrap { padding: 4px 0 20px; }\n.tardios-header {\n    display: flex; justify-content: space-between; align-items: flex-start;\n    gap: 20px; flex-wrap: wrap; margin-bottom: 18px;\n}\n.tardios-header h3 { margin: 0 0 4px; font-size: 1.05rem; color: #1e293b; }\n.tardios-header p { margin: 0; font-size: 0.82rem; color: #64748b; max-width: 520px; }\n.tardios-filtros { display: flex; gap: 14px; align-items: center; flex-wrap: wrap; }\n.tardios-filtros label {\n    display: flex; align-items: center; gap: 6px;\n    font-size: 0.78rem; font-weight: 600; color: #475569;\n    background: #fff; border: 1px solid #e2e8f0; border-radius: 8px; padding: 6px 12px;\n}\n.tardios-filtros input {\n    border: 1px solid #e2e8f0; border-radius: 5px; padding: 3px 6px; font-size: 0.82rem;\n}\n.tardios-filtros input[type=\"number\"] { width: 52px; text-align: center; }\n\n.tardios-info { font-size: 0.88rem; color: #64748b; padding: 14px 0; }\n.tardios-ok { color: #166534; font-weight: 600; }\n.tardios-erro {\n    font-size: 0.85rem; color: #991b1b; background: #fee2e2;\n    border: 1px solid #fca5a5; border-radius: 8px; padding: 10px 14px;\n}\n\n.tardios-grupo { margin-bottom: 22px; }\n.tardios-grupo-titulo {\n    display: flex; align-items: center; gap: 10px;\n    font-size: 0.86rem; font-weight: 700; color: #92400e;\n    background: #fff7ed; border: 1px solid #fed7aa;\n    border-radius: 8px 8px 0 0; padding: 9px 14px;\n}\n.tardios-grupo-total { margin-left: auto; font-variant-numeric: tabular-nums; }\n.tardios-tabela { width: 100%; border-collapse: collapse; font-size: 0.82rem; }\n.tardios-tabela th {\n    background: #f8fafc; text-align: left; font-weight: 700; font-size: 0.72rem;\n    text-transform: uppercase; letter-spacing: 0.3px; color: #64748b;\n    padding: 7px 10px; border-bottom: 2px solid #e2e8f0;\n}\n.tardios-tabela td { padding: 7px 10px; border-bottom: 1px solid #f1f5f9; color: #1e293b; }\n/* a data de carga e o dado que justifica a linha estar aqui */\n.tardios-carga { font-weight: 700; color: #b45309; }\n\n/* faixa de aviso no topo das Despesas */\n.tardios-faixa {\n    display: flex; align-items: flex-start; gap: 12px;\n    background: #fff7ed; border: 1px solid #fdba74; border-radius: 10px;\n    padding: 12px 16px; margin-bottom: 14px;\n}\n.tardios-faixa-icone { font-size: 1.1rem; line-height: 1.4; }\n.tardios-faixa-texto { flex: 1; font-size: 0.84rem; color: #7c2d12; line-height: 1.55; }\n.tardios-faixa-btn {\n    align-self: center; white-space: nowrap;\n    background: #ea580c; color: #fff; border: none; border-radius: 7px;\n    padding: 7px 14px; font-size: 0.8rem; font-weight: 700; cursor: pointer;\n}\n.tardios-faixa-btn:hover { background: #c2410c; }\n\n\n/* \"Atualizar reconciliacoes\": manda o reconciliador associar os movimentos que\n   ja tem fatura lancada aqui. Azul e nao verde porque nao e o gemeo do \"ja\n   tratei\" — este mexe no documento do contabilista, aquele so arruma a lista. */\n.tardios-btn-atualizar {\n    margin-left: 8px; white-space: nowrap;\n    background: #fff; color: #1d4ed8; border: 1px solid #93c5fd;\n    border-radius: 6px; padding: 4px 10px;\n    font-size: 0.75rem; font-weight: 700; cursor: pointer;\n}\n.tardios-btn-atualizar:hover:not(:disabled) { background: #dbeafe; }\n.tardios-btn-atualizar:disabled { opacity: 0.55; cursor: default; }\n\n/* A barra ocupa a largura toda, como a caixa de filtros por baixo. O\n   .shared-subnav geral tem width: fit-content, que a encolhia ao conteúdo e não\n   deixava os botões crescerem. Preso a esta barra, para não mexer nas outras\n   páginas que usam a mesma classe. */\n.shared-subnav.subnav-reconciliador { width: 100%; box-sizing: border-box; }\n\n/* Separadores em três andares: ícone em cima, e o título nas duas linhas por\n   baixo. Sem coluna para o ícone, cada botão fica com a largura do seu texto.\n\n   As medidas não são a olho: com o texto a 12px e 10px de margem lateral, os\n   nove somam ~865px (folgas incluídas) e cabem nos ~1050px úteis. Eram dez e\n   somavam ~970px — \"Faturas s/ extrato\" saiu e a fila ficou com mais folga; o\n   corpo mantém-se nos 12px porque é o que deixa lugar a um separador novo sem\n   a fila passar a duas linhas. */\n.subnav-btn-duplo {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    row-gap: 1px;\n    line-height: 1.2;\n    white-space: nowrap;\n    text-align: center;\n    padding: 6px 10px;\n\n    /* Todos com a mesma largura: crescem em partes iguais para encher a fila e\n       nunca encolhem abaixo dos 113px, que é o que a palavra mais larga —\n       \"RECONCILIADOS\", 93px a 12px de letra — precisa com as margens. Nove a\n       113px dão 1017px, e com as folgas entre botões ~1055px; numa fila mais\n       estreita do que isso, desliza. */\n    flex: 1 0 113px;\n    min-width: 0;\n}\n.subnav-btn-duplo .subnav-icone {\n    font-size: 19px;\n    line-height: 1;\n    margin-bottom: 11px;   /* afasta o título do ícone */\n}\n/* Separador de uma palavra só: ocupa a altura das duas linhas e fica a meio. */\n.subnav-btn-duplo .subnav-unico {\n    min-height: 2.4em;\n    display: flex;\n    align-items: center;\n}\n/* As duas linhas de texto declaradas com os mesmos valores, em vez de contarem\n   com o que herdam: assim ficam iguais mesmo que outra folha de estilos mexa no\n   botão — e o tema \"simple\", por exemplo, mexe. */\n.subnav-btn-duplo > span:not(.subnav-icone) {\n    font-family: inherit;\n    font-size: 12px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: .01em;\n    line-height: 1.2;\n}\nbody[data-page-theme=\"simple\"] .subnav-btn-duplo > span:not(.subnav-icone) {\n    font-size: 12px;\n    font-weight: 400;\n}\n\n\n/* Gasto do mês e cartões sem extrato.\n   O número só é fiável quando todos os cartões têm extrato; quando não tem,\n   diz-se, em vez de mostrar um total curto como se fosse o certo. */\n.summary-item.gasto-mes .summary-value { color: #0f172a; }\n\n\n.aviso-sem-extrato {\n    display: flex; gap: 12px; align-items: flex-start;\n    background: #fffbeb; border: 1px solid #fcd34d; border-radius: 8px;\n    padding: 12px 14px; margin-bottom: 16px;\n}\n.aviso-sem-extrato .aviso-icone { font-size: 18px; line-height: 1.2; flex: 0 0 auto; }\n.aviso-sem-extrato strong { display: block; color: #92400e; font-size: 14px; }\n.aviso-sem-extrato .aviso-detalhe {\n    display: block; color: #a16207; font-size: 12.5px; margin-top: 2px;\n}\n.aviso-sem-extrato .aviso-lista {\n    margin: 8px 0 0; padding-left: 18px; color: #78350f; font-size: 12.5px;\n    columns: 2; column-gap: 26px;\n}\n.aviso-sem-extrato .aviso-lista li { margin-bottom: 2px; break-inside: avoid; }\n.aviso-sem-extrato .aviso-digitos {\n    color: #a16207; font-variant-numeric: tabular-nums; margin-left: 4px;\n}\n@media (max-width: 720px) { .aviso-sem-extrato .aviso-lista { columns: 1; } }\n\n\n/* Sem um único extrato do mês não há valor a mostrar. Fica texto, e em corpo\n   mais pequeno, para não ocupar o lugar de um número que não existe. */\n.summary-item.gasto-mes .sem-extratos {\n    font-size: 0.62em; font-weight: 600; letter-spacing: 0.2px;\n    text-transform: uppercase; color: #b45309; white-space: nowrap;\n}\n\n\n/* ---- Barra de resumo: títulos e valores todos iguais e ao centro ----\n   Antes cada número tinha o seu tamanho e o seu alinhamento, e a barra lia-se\n   como três coisas soltas em vez de três colunas comparáveis. */\n.summary-bar .summary-item {\n    align-items: center;\n    text-align: center;\n    justify-content: flex-start;\n}\n.summary-bar .summary-label {\n    font-size: 0.85rem;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    margin-bottom: 4px;\n}\n.summary-bar .summary-value {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    font-size: 1.35rem;\n    font-weight: 700;\n    line-height: 1.25;\n    font-variant-numeric: tabular-nums;\n}\n/* A segunda linha de um valor (o montante, por baixo da contagem) é do mesmo\n   tamanho: são dois registos, não um registo e uma legenda. */\n.summary-bar .summary-sub {\n    font-size: 1em;\n    font-weight: 700;\n    line-height: 1.25;\n}\n/* Excepção assumida: aqui não há número nenhum, há uma frase. Ao tamanho dos\n   números ocuparia meia barra. */\n.summary-item.gasto-mes .sem-extratos {\n    font-size: 0.55em; letter-spacing: 0.2px;\n}\n\n\n/* ---- Barra de resumo, versão final ----\n   Três colunas comparáveis: mesmo título, mesmo valor, mesma cor. Antes cada\n   uma tinha a sua cor e o seu peso, e a cor lia-se como significado quando era\n   só decoração. O que assinala uma pendência é o ⚠️ e o texto, não o tom. */\n.summary-bar { align-items: stretch; }\n\n.summary-bar .summary-item {\n    align-items: center;\n    justify-content: center;      /* ao centro do centro, também na vertical */\n    text-align: center;\n}\n.summary-bar .summary-label {\n    font-size: 0.95rem;\n    font-weight: 700;\n    color: #475569;\n    letter-spacing: 0.03em;\n    margin-bottom: 5px;\n}\n.summary-bar .summary-value,\n.summary-bar .summary-sub,\n.summary-item.gasto-mes .sem-extratos {\n    font-size: 1.15rem;\n    font-weight: 500;             /* sem negrito, como pedido */\n    color: #334155;\n    line-height: 1.3;\n    letter-spacing: normal;\n    text-transform: none;\n}\n.summary-bar .summary-value { font-variant-numeric: tabular-nums; }\n/* A cor de alerta sai dos números: quem avisa é o ⚠️ e o texto. */\n.summary-item.gasto-mes.incompleto .summary-label,\n.summary-item.gasto-mes.incompleto .summary-value,\n.summary-item.gasto-mes .summary-value { color: #334155; }\n\n\n/* ---- Barra de resumo: títulos em destaque, valores discretos ----\n   A hierarquia inverte-se de propósito: o título é a etiqueta que se procura,\n   o número é o que se lê depois de a ter encontrado. #3182ce é o azul que a\n   aplicação já usa como cor de destaque, não é um tom novo. */\n.summary-bar .summary-label {\n    color: #3182ce;\n    white-space: nowrap;          /* \"Revolut sem fatura\" numa linha só */\n}\n\n\n.summary-bar .summary-value,\n.summary-bar .summary-sub,\n.summary-item.gasto-mes .sem-extratos {\n    font-size: 0.65rem;           /* 1,15rem - 0,5 */\n}\n\n\n/* ---- Barra de resumo: acertos finais ----\n   Os títulos passam a encostar ao topo. Estavam centrados na vertical, e como\n   as colunas têm alturas diferentes (uma tem o valor em duas linhas, outra em\n   uma), o centro de cada uma caía a alturas diferentes e o \"FATURAS\" descaía\n   em relação aos vizinhos. Encostando ao topo, os três ficam na mesma linha. */\n.summary-bar .summary-item { justify-content: flex-start; }\n\n.summary-bar .summary-label,\n.summary-item.gasto-mes.incompleto .summary-label { color: #991b1b; }\n\n\n/* Os valores voltam a subir, para o mesmo corpo dos títulos: distinguem-se\n   pelo peso e pela cor, já não precisam de se distinguir pelo tamanho. */\n.summary-bar .summary-value,\n.summary-bar .summary-sub,\n.summary-item.gasto-mes .sem-extratos {\n    font-size: 0.95rem;\n}\n\n\n/* Títulos maiores. Continuam com quebra de linha proibida, por isso a barra\n   alarga em vez de os partir em duas linhas. */\n.summary-bar .summary-label { font-size: 1.1rem; }\n\n\n/* Valores ao mesmo corpo dos títulos: distinguem-se pelo peso e pela cor. */\n.summary-bar .summary-value,\n.summary-bar .summary-sub,\n.summary-item.gasto-mes .sem-extratos {\n    font-size: 1.1rem;\n}\n\n\n/* ---- Filtros de coluna da lista de despesas ---- */\n.filtro-col { position: relative; display: inline-block; margin-left: 5px; }\n.filtro-col-btn {\n    border: none; background: none; cursor: pointer; padding: 0 2px;\n    font-size: 0.6rem; color: #94a3b8; line-height: 1; vertical-align: middle;\n}\n.filtro-col-btn:hover { color: #3182ce; }\n.filtro-col-btn.ativo { color: #3182ce; font-weight: 700; }\n.filtro-col-conta {\n    display: inline-block; margin-left: 3px; padding: 0 4px; border-radius: 8px;\n    background: #3182ce; color: #fff; font-size: 0.58rem; line-height: 1.5;\n}\n.filtro-col-painel {\n    position: absolute; top: calc(100% + 6px); left: 0; z-index: 60;\n    width: 260px; background: #fff; border: 1px solid #e2e8f0; border-radius: 8px;\n    box-shadow: 0 8px 24px rgba(15, 23, 42, 0.16);\n    padding: 8px; display: flex; flex-direction: column; gap: 6px;\n    text-transform: none; letter-spacing: normal; font-weight: 400;\n}\n.filtro-col-busca {\n    padding: 5px 8px; border: 1px solid #e2e8f0; border-radius: 6px;\n    font-size: 12px; font-family: inherit; color: #374151;\n}\n.filtro-col-busca:focus { border-color: #3b82f6; outline: none; }\n.filtro-col-acoes { display: flex; gap: 6px; }\n.filtro-col-acoes button {\n    flex: 1; padding: 4px 6px; border-radius: 5px; font-size: 11px;\n    background: #f8fafc; color: #475569; border: 1px solid #e2e8f0;\n    cursor: pointer; font-family: inherit;\n}\n.filtro-col-acoes button:hover { background: #f1f5f9; }\n.filtro-col-lista { max-height: 240px; overflow-y: auto; overscroll-behavior: contain; }\n.filtro-col-item {\n    display: flex; align-items: flex-start; gap: 7px; padding: 4px 5px;\n    border-radius: 5px; font-size: 12px; color: #374151; cursor: pointer;\n    line-height: 1.35; text-align: left;\n}\n.filtro-col-item:hover { background: #f8fafc; }\n.filtro-col-item input { margin-top: 2px; flex: 0 0 auto; cursor: pointer; }\n.filtro-col-vazio { margin: 0; padding: 6px 5px; font-size: 11px; color: #94a3b8; }\n\n/* O cabeçalho da tabela tem de deixar o painel sair para fora da célula. */\n.despesas-table thead th { overflow: visible; position: relative; }\n.table-container { overflow: visible !important; }\n\n.btn-limpar-filtros {\n    padding: 3px 10px; border-radius: 6px; font-size: 0.8rem; font-family: inherit;\n    background: #fff; color: #991b1b; border: 1px solid #991b1b; cursor: pointer;\n}\n.btn-limpar-filtros:hover { background: #fef2f2; }\n\n\n/* ---- Ordenação por coluna ---- */\n.despesas-table thead th .th-ordenavel {\n    cursor: pointer; user-select: none; display: inline-flex;\n    align-items: center; gap: 4px;\n}\n.despesas-table thead th .th-ordenavel:hover { color: #3182ce; }\n.th-seta { font-size: 0.62rem; color: #cbd5e1; line-height: 1; }\n.th-seta.ativa { color: #3182ce; }\n\n\n/* Sete colunas não cabem numa linha em todos os ecrãs: a barra quebra em vez\n   de encolher os números até ficarem ilegíveis. */\n.summary-bar.compact { flex-wrap: wrap; gap: 14px 26px; row-gap: 12px; }\n.summary-bar .summary-item { min-width: 92px; }\n\n\n/* As sete colunas repartem a barra em partes iguais. O título ocupa sempre a\n   altura de duas linhas — mesmo o que só tem uma — para os valores de todas as\n   colunas ficarem à mesma altura. */\n.summary-bar.compact .summary-item {\n    flex: 1 1 0;\n    min-width: 118px;\n}\n.summary-bar .summary-label {\n    min-height: 2.6em;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    line-height: 1.3;\n}\n\n\n/* Marca de valor parcial, no mês que ainda não fechou. */\n.summary-bar .summary-sub.parcial {\n    font-size: 12px !important; font-weight: 600; color: #b45309; text-transform: uppercase;\n    letter-spacing: 0.3px;\n    margin-top: 6px;\n}\n\n/* Resultado explícito comum ao QR Code e ao registo manual. */\n.despesa-resultado-overlay { position: fixed; inset: 0; z-index: 20000 !important; display: flex; align-items: center; justify-content: center; background: #14253699; padding: 16px; }\n.despesa-resultado { background: white; color: #294b69; border-radius: 14px; padding: 24px; width: min(100%, 460px); max-height: 90vh; overflow: auto; box-sizing: border-box; border-top: 5px solid #d69e2e; }\n.despesa-resultado-sucesso { border-top-color: #239469; }\n.despesa-resultado-erro { border-top-color: #c53030; }\n.despesa-resultado h2 { font-size: 20px; margin: 0 0 14px; }\n.despesa-resultado p { font-size: 14px; line-height: 1.5; }\n.despesa-resultado dl { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; background: #f1f7fc; padding: 14px; border-radius: 8px; }\n.despesa-resultado dd { margin: 0; font-weight: 600; }\n.despesa-resultado .btn-scan { width: 100%; margin-top: 12px; }\n.despesa-resultado-aviso { color: #975a16; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
